import {
  SETTINGS_ICON_ACTIVE_TOGGLE,
  GET_PAGINATED_PRODUCTS,
  GET_PRODUCT_OPTIONS,
  CREATE_PACK_TYPE_ASSIGNMENT,
  GET_PRODUCT_PACK_TYPE_ASSIGNMENTS,
  GET_PROFILE_DETAILS,
  GET_TRANSPORTER_LIST,
  SET_PROFILE_IMAGE,
} from 'src/redux/Actions/Type';

const initialState = {
  isSettingsIconActive: false,
  productList: [],
  productOptions: {
    products: [],
    pagination: {},
  },
  addPackTypeAssignment: {},
  getProductPackTypeAssignments: [],
  getProfileDetails: {},
  transporterList: [],
  profileImage: null,
};

const SettingsReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SETTINGS_ICON_ACTIVE_TOGGLE:
      return {
        ...state,
        isSettingsIconActive: payload,
      };
    case GET_PAGINATED_PRODUCTS:
      return {
        ...state,
        productList: payload,
      };
    case GET_PRODUCT_OPTIONS:
      return {
        ...state,
        productOptions: payload,
      };
    case CREATE_PACK_TYPE_ASSIGNMENT:
      return {
        ...state,
        addPackTypeAssignment: payload,
      };
    case GET_PRODUCT_PACK_TYPE_ASSIGNMENTS:
      return {
        ...state,
        getProductPackTypeAssignments: payload,
      };
    case GET_PROFILE_DETAILS:
      return {
        ...state,
        getProfileDetails: payload,
      };
    case SET_PROFILE_IMAGE:
      return {
        ...state,
        profileImage: payload,
      };
    case GET_TRANSPORTER_LIST:
      return {
        ...state,
        transporterList: payload,
      };
    default:
      return state;
  }
};

export default SettingsReducer;
